<div class="raptor-section-offramp">

  <!-- DEFAULT LAYOUT -->
  <open-raptor-section-offramp-default [section]="section" [form]="form"></open-raptor-section-offramp-default>
</div>